import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IInvoice } from "@/models/invoice.entity";
import invoiceService from "@/services/mrfiktiv/services/invoice-service";
import { MrfiktivInvoiceControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const InvoicePageDataProvider = new (class extends AbstractPageDataProvider<
  IInvoice,
  MrfiktivInvoiceControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivInvoiceControllerGetParamsGen): Promise<IPageViewModel<IInvoice>> {
    const res = await invoiceService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IInvoice[];

    return { meta, data };
  }
})();
